import axios from 'axios';
import { ICountryResponse } from 'organisms/GeoPopup/types';
import { errorWrapper } from 'commerce/utils/network';

export const getCountryCode = () => {
  return errorWrapper<ICountryResponse>(getCountryCode.name, () =>
    axios.get('/api/countryCode'),
  );
};
